export const CheckLicencePlate = (value: string): boolean => {
    //const el = value.replace(/[^\x20-\x7Eěščřžýáíéůóú]/g, '') (pro odstranovani emojis a podobne, kdyz to bylo potreba)
    const regex = new RegExp(/[^A-Za-z0-9\s]/, "g");
    return regex.test(value);
};
